export const offsetXs = '6px';
export const offsetSm = '10px';
export const offsetMd = '16px';
export const offsetLg = '24px';
export const offsetXl = '36px';
